import React from "react";
import ImageDisplay from "components/AttachmentPreview/Display/ImageDisplay";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import ReactDOM from "react-dom";

const styles = {
  previewDialog: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "1100",
    color: "black",
  },
  previewDialogBackdrop: {
    height: "inherit",
    width: "inherit",
    position: "fixed",
    backgroundColor: "black",
    top: "0",
    left: "0",
    zIndex: "-1",
    pointerEvents: "none",
    opacity: "0.7",
  },
  closeIcon: {
    width: "25px",
    cursor: "pointer",
    fill: "#9e9e9e",
    boxShadow: "rgb(0 0 0 / 35%) 0px 5px 15px",
    borderRadius: '50%',
    background: 'white'
  },

  closeContainer: {
    padding: "20px",
    position: "absolute",
    top: 0,
    right: 0,
  },
};

function ImageModal({
  closePreviewDailog,
  preventDefaultOnClick,
  attachment,
  type,
}) {
  const classes = styles;

  const DisplayImageModal = () => {
    return (
      <div style={classes.previewDialog} onClick={closePreviewDailog}>
        <div style={classes.previewDialogBackdrop}></div>
        <div style={classes.closeContainer}>
          <CloseIcon style={classes.closeIcon} onClick={closePreviewDailog} />
        </div>
        <div
          className="imagePreviewContentContainer"
          onClick={preventDefaultOnClick}
        >
          <ImageDisplay attachmentSrc={attachment} type={type} />
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <DisplayImageModal />,
        document.getElementById("modal-root")
      )}
    </React.Fragment>
  );
}

export default ImageModal;
